import React, { useState } from "react";
import DynamicSelector from "../DynamicSelector";
import DateRangePicker from "./Calendar";
import StartDatePicker from "./StartDatePicker.js";
import AirportTrafficResults from "./AirportTrafficResults";
import FetchYears from "./FetchYears";
import MultiSelector from "../../components/MultiSelector.js";

function AirportTraffic({ AirportSelection }) {
  let Selector;

  //Radio Button 1
  const [selectedTimeOption, setselectedTimeOption] = useState("");

  //Radio Button 2
  const [selectedRegionIndicator, setselectedRegionIndicator] = useState("");

  //Dropdown 1
  const [selectedTime, setselectedTime] = useState([]);

  //Dropdown2
  const [MeasurementIndicator, setMeasurementIndicator] = useState("");

  //Nuts Selector
  const [NutsSelector, setNutsSelector] = useState("");

  //Check if Search is clicked
  const [searchClicked, setsearchClicked] = useState(false);

  //State for Calendar ( Month and Day Options)
  const [startDate, setStartDate] = useState("");
  const [endDate, setendDate] = useState("");

  //Change Search and Clear button background color when clicked
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(null);

  const buttonStyle = {
    backgroundColor: "white",
    borderRadius: "4px",
    padding: "8px 16px",
    margin: "0 8px",
    cursor: "pointer",
  };

  const selectedButtonStyle = {
    ...buttonStyle,
    backgroundColor: "rgb(0, 102, 255)",
    color: "black",
  };

  //Change of 1st Radio Buttons
  const handleOptionChange = (event) => {
    setselectedTimeOption(event.target.value);
  };

  //Change of 2nd Radio Buttons
  const handleOptionChange2 = (event) => {
    setselectedRegionIndicator(event.target.value);
  };

  function handleSearchClick() {
    setsearchClicked(true);
    setSelectedButtonIndex(0);
  }

  function handleClearClick() {
    setselectedTimeOption("");
    setselectedRegionIndicator("");
    setselectedTime("Επιλογή από τη λίστα");
    setMeasurementIndicator("Επιλογή από τη λίστα");
    setsearchClicked(false);
    //reset clicked color
    setSelectedButtonIndex(1);
  }

  //Get AirpotSelections and take codes
  const codes = [];
  for (let i = 0; i < AirportSelection.length; i++) {
    const str = JSON.stringify(AirportSelection[i]);
    codes.push(str.slice(-4, -1));
  }

  const SelectorOptions2 = {
    defaultText: "Επιλογή από τη λίστα",
    options: [
      { value: "Αφικνούμενοι επιβάτες", label: "Αφικνούμενοι επιβάτες" },
      { value: "Αναχωρούμενοι επιβάτες", label: "Αναχωρούμενοι επιβάτες" },
      { value: "Συνολικοί Επιβάτες", label: "Συνολικοί Επιβάτες" },
      { value: "Εμπορεύματα", label: "Εμπορεύματα" },
    ],
  };

  let NutSelectorOptions2 = {
    title: "",
    default_text: "Επέλεξε από τη λίστα",
    options: [
      { key: "Περιφέρεια 1 (Κωδικός 1)" },
      { key: "Περιφέρεια 2 (Κωδικός 2)" },
      { key: "Περιφέρεια 3 (Κωδικός 3)" },
      { key: "Περιφέρεια 4 (Κωδικός 4)" },
      { key: "Περιφέρεια 5 (Κωδικός 5)" },
      { key: "Περιφέρεια 6 (Κωδικός 6)" },
      { key: "Περιφέρεια 7 (Κωδικός 7)" },
      { key: "Περιφέρεια 8 (Κωδικός 8)" },
      { key: "Περιφέρεια 9 (Κωδικός 9)" },
      { key: "Περιφέρεια 10 (Κωδικός 10)" },
      { key: "Περιφέρεια 11 (Κωδικός 11)" },
    ],
  };

  Selector = (
    <MultiSelector
      passData={setNutsSelector}
      props={NutSelectorOptions2}
    ></MultiSelector>
  );

  return (
    <div className="container" style={{ marginTop: "3%" }}>
      <p style={{ marginBottom: "5%" }}>
        Μάθε για την επιβατική και εμπορευματική αεροπορική κίνηση σε επίπεδο
        αεροδρομίου, περιφέρειας και πανελλαδικά για το χρονικό διάστημα που σε
        ενδιαφέρει.
      </p>

      <hr style={{ borderColor: "#b3e6ff" }}></hr>
      <h5>0.1 Χρονική περίοδος</h5>
      <p>Επίλεξε τον δείκτη μέτρησης</p>
      <div className="filters-wrapper" style={{ paddingLeft: "2%" }}>
        <p style={{ marginTop: "2%" }}>Επίλεξε μονάδα χρόνου</p>
        <div style={{ display: "flex", marginBottom: "3%" }}>
          <label>
            <input
              type="radio"
              value="Ανα έτος"
              checked={selectedTimeOption === "Ανα έτος"}
              onChange={handleOptionChange}
            />
            Ανα έτος
          </label>
          <label style={{ marginRight: "3%", marginLeft: "2%" }}>
            <input
              type="radio"
              value="Ανα μήνα"
              checked={selectedTimeOption === "Ανα μήνα"}
              onChange={handleOptionChange}
            />
            Ανα μήνα
          </label>
          <label>
            <input
              type="radio"
              value="Ανα ημέρα"
              checked={selectedTimeOption === "Ανα ημέρα"}
              onChange={handleOptionChange}
            />
            Ανα ημέρα
          </label>
        </div>

        <hr
          style={{ borderColor: "#b3e6ff", width: "90%", marginRight: "8%" }}
        ></hr>

        <p>Επίλεξε χρονική περίοδο</p>
        {selectedTimeOption === "Ανα έτος" ? (
          <div style={{ marginBottom: "5%" }}>
            <FetchYears
              passData={setselectedTime}
              selectionsLimit={1}
            ></FetchYears>
          </div>
        ) : selectedTimeOption === "Ανα μήνα" ? (
          <DateRangePicker
            passStartDate={setStartDate}
            passEndDate={setendDate}
          />
        ) : (
          <StartDatePicker passStartDate={setStartDate} />
        )}
      </div>

      <hr style={{ borderColor: "#b3e6ff" }}></hr>
      <h5>0.2 Ανάλυση Δεδομένων</h5>
      <p>Επίλεξε τον δείκτη μέτρησης</p>
      <div
        className="filters-wrapper"
        style={{ paddingLeft: "2%", marginBottom: "2%" }}
      >
        <p style={{ marginTop: "2%" }}>Δες τα δεδομένα, ανά: </p>
        <div style={{ display: "flex", marginBottom: "3%" }}>
          <label>
            <input
              type="radio"
              value="Αεροδρόμιο"
              checked={selectedRegionIndicator === "Αεροδρόμιο"}
              onChange={handleOptionChange2}
            />
            Αεροδρόμιο
          </label>
          <label style={{ marginRight: "3%", marginLeft: "2%" }}>
            <input
              type="radio"
              value="Γεωγραφική περιοχή"
              checked={selectedRegionIndicator === "Γεωγραφική περιοχή"}
              onChange={handleOptionChange2}
            />
            Γεωγραφική περιοχή(κωδικοποίηση NUTS 2)
          </label>
          <label>
            <input
              type="radio"
              value="Σύνολο Αεροδρομίων"
              checked={selectedRegionIndicator === "Σύνολο Αεροδρομίων"}
              onChange={handleOptionChange2}
            />
            Σύνολο Αεροδρομίων
          </label>
        </div>

        <hr
          style={{ borderColor: "#b3e6ff", width: "90%", marginRight: "8%" }}
        ></hr>

        <p>Επίλεξε τον δείκτη μέτρησης</p>

        <div style={{ marginBottom: "5%" }}>
          <DynamicSelector
            defaultText={SelectorOptions2.defaultText}
            options={SelectorOptions2.options}
            onSelect={setMeasurementIndicator}
          ></DynamicSelector>
        </div>

        {selectedRegionIndicator === "Γεωγραφική περιοχή" ? (
          <div style={{ width: "20%" }}>{Selector} </div>
        ) : (
          <></>
        )}
      </div>

      {/* TODO: OPEN BUTTON WHEN VALUES CHECKED */}

      <div style={{ display: "flex", marginBottom: "5%" }}>
        {selectedRegionIndicator.length !== 0 &&
        MeasurementIndicator.length !== 0 &&
        selectedTimeOption.length !== 0 ? (
          <button
            style={
              selectedButtonIndex === 0 ? selectedButtonStyle : buttonStyle
            }
            onClick={handleSearchClick}
          >
            {" "}
            Αναζήτηση
          </button>
        ) : (
          <button
            style={
              selectedButtonIndex === 0 ? selectedButtonStyle : buttonStyle
            }
            disabled
          >
            {" "}
            Αναζήτηση
          </button>
        )}

        <button
          style={selectedButtonIndex === 1 ? selectedButtonStyle : buttonStyle}
          onClick={handleClearClick}
        >
          {" "}
          Εκκαθάριση δεδομένων
        </button>
      </div>

      {searchClicked === true ? (
        <AirportTrafficResults
          TimeOption={selectedTimeOption}
          RegionIndicator={selectedRegionIndicator}
          Time={selectedTime}
          MeasurementIndicator={MeasurementIndicator}
          AirportCodes={codes}
          NutsSelection={NutsSelector}
          startDate={startDate}
          endDate={endDate}
        ></AirportTrafficResults>
      ) : (
        <></>
      )}
    </div>
  );
}

export default AirportTraffic;
